import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// index is entry point, creates app
ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);